module.exports = __webpack_public_path__ + "media/images/birthday/birthday-template-am-a39c301193f00648349fa778f901f313.png";